import { render, staticRenderFns } from "./CalendarYear.vue?vue&type=template&id=4046eb9f&"
import script from "./CalendarYear.vue?vue&type=script&setup=true&lang=js&"
export * from "./CalendarYear.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports